module.exports = __webpack_public_path__ + "a5d265bdf5faa64332c8bb4439aeb840.png";